import { TaskStates, TaskStatus } from "./constants";
import moment from "moment";
import { TaskCategory, TaskTemplate } from "./types";

const getTopOfListSortIndex = (maxSortIndex: number) => {
  console.log("maxSortIndex", maxSortIndex);
  const sortIndexNumbers = maxSortIndex.toString().split("") ?? [];
  sortIndexNumbers[0] = (parseInt(sortIndexNumbers[0]) + 1).toString();
  return parseInt(sortIndexNumbers.join(""));
};

const getBottomOfListSortIndex = (minSortIndex: number) => {
  const sortIndexNumbers = minSortIndex.toString().split("") ?? [];
  if (sortIndexNumbers[0] === "1") {
    // 1000 -> 0900
    sortIndexNumbers[1] = "9";
  }
  sortIndexNumbers[0] = (parseInt(sortIndexNumbers[0]) - 1).toString();
  return parseInt(sortIndexNumbers.join(""));
};

const getBetweenSortIndex = (
  aboveSortIndex: number,
  belowSortIndex: number
) => {
  return Math.floor((aboveSortIndex + belowSortIndex) / 2);
};

const getTaskStatus = (task: Forme.EnrichedTask) => {
  const dueDate = task.dueDate;
  if (task.taskStates?.at(-1)?.state === TaskStates.Complete) {
    return TaskStatus.Complete;
  }
  if (dueDate && moment(dueDate).isBefore(moment(), "day")) {
    return TaskStatus.Overdue;
  }
  return TaskStatus.Open;
};

const getTaskCategory = (
  task: Forme.EnrichedTask | TaskTemplate
): TaskCategory => {
  if ("isPreOnboardingTask" in task && task.isPreOnboardingTask) {
    return TaskCategory.PRE_ONBOARDING;
  }

  return task.productPhase == "PHASE_1"
    ? TaskCategory.ONBOARDING
    : task.productTopic
    ? task.productTopic
    : TaskCategory.ONGOING_WEALTH_MANAGEMENT;
};

const getTaskDueDateDiff = (dueDate: Date | null | undefined) => {
  const dueDateDiff = dueDate ? moment(dueDate).diff(moment(), "days") : null;
  const isDueDatePast = typeof dueDateDiff === "number" && dueDateDiff < 0;
  return {
    dueDateDiff,
    isDueDatePast,
  };
};

const getTaskDueDatePayload = (
  dueDate: Date | moment.Moment | null | undefined
) => {
  return dueDate ? dueDate.toISOString() : undefined;
};

const getTaskDueDate = (dueDate: Date | string | null | undefined) => {
  if (!dueDate) return null;
  if (typeof dueDate === "string") {
    return moment(dueDate.split("T")[0], "YYYY-MM-DD").toDate();
  }
  return dueDate;
};

export {
  getTopOfListSortIndex,
  getBottomOfListSortIndex,
  getBetweenSortIndex,
  getTaskStatus,
  getTaskCategory,
  getTaskDueDateDiff,
  getTaskDueDatePayload,
  getTaskDueDate,
};
